/* Nexora homepage sliders: arrows, swipe (native scroll), slow auto-scroll that stops on hover/touch. */
(function () {
  if (window.NexoraSlider) return;
  function init(root) {
    if (root.dataset.nxReady) return;
    root.dataset.nxReady = '1';
    var track = root.querySelector('[data-nx-track]');
    if (!track) return;
    var prev = root.querySelector('[data-nx-prev]');
    var next = root.querySelector('[data-nx-next]');
    var rtl = getComputedStyle(track).direction === 'rtl';
    function step() {
      var item = track.children[0];
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return item ? item.getBoundingClientRect().width + gap : track.clientWidth;
    }
    function pos() { return Math.abs(track.scrollLeft); }
    function max() { return track.scrollWidth - track.clientWidth; }
    function atEnd() { return pos() >= max() - 4; }
    function atStart() { return pos() <= 4; }
    function go(dir) { track.scrollBy({ left: (rtl ? -1 : 1) * dir * step(), behavior: 'smooth' }); }
    function update() {
      var can = max() > 4;
      root.classList.toggle('nx-static', !can);
      if (prev) prev.disabled = !can || atStart();
      if (next) next.disabled = !can || atEnd();
    }
    var auto = root.dataset.autoplay === 'true' && !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var ms = (parseFloat(root.dataset.speed) || 5) * 1000;
    var hovering = false, stopped = false, visible = true;
    function stop() { stopped = true; }
    function tick() {
      if (!auto || stopped || hovering || !visible || document.hidden || max() <= 4) return;
      if (atEnd()) track.scrollTo({ left: 0, behavior: 'smooth' });
      else go(1);
    }
    if (prev) prev.addEventListener('click', function () { stop(); go(-1); });
    if (next) next.addEventListener('click', function () { stop(); go(1); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    root.addEventListener('mouseenter', function () { hovering = true; });
    root.addEventListener('mouseleave', function () { hovering = false; });
    root.addEventListener('focusin', function () { hovering = true; });
    root.addEventListener('focusout', function () { hovering = false; });
    root.addEventListener('touchstart', stop, { passive: true });
    root.addEventListener('wheel', function (e) { if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) stop(); }, { passive: true });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { visible = entries[0].isIntersecting; }, { threshold: 0.3 }).observe(root);
    }
    update();
    if (auto) setInterval(tick, ms);
  }
  function initAll() { document.querySelectorAll('[data-nx-slider]').forEach(init); }
  window.NexoraSlider = { initAll: initAll };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
